import React from 'react';

// Create a context with a default value of an object containing scrollPosition and setScrollPosition
const ScrollPositionContext = React.createContext({
  scrollPosition: 0,
  setScrollPosition: () => {}
});

export default ScrollPositionContext;
